/**
 * MovementAnalysisPage
 *
 * AI-powered movement analysis with video upload, camera recording,
 * structured Gemini output (R6), timestamp markers (R7), score dials (R8),
 * and keyboard shortcuts (R9).
 *
 * Mode: Deep Analysis (Mode 3)
 */
import React from 'react';
import { Camera } from 'lucide-react';
import MovementAnalysisContent from '../../components/movement-analysis/MovementAnalysisContent';

export default function MovementAnalysisPage() {
  return (
    <div className="min-h-full bg-[#040608] text-zinc-100 p-4 md:p-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <Camera className="text-orange-400" size={24} />
          <h1 className="text-2xl font-bold text-white">Movement Analysis</h1>
          <span className="text-xs text-zinc-500">AI-powered form analysis</span>
        </div>
        <MovementAnalysisContent />
      </div>
    </div>
  );
}
